import { NgModule } from '@angular/core';

import { MaterialModule } from '@modules/material.module';
import { SharedModule } from '../../shared.module';
import { CadastroLoteLancamentosModule } from '../../../pages/financeiro/cadastro-lote-lancamentos/cadastro-lote-lancamentos.module';
import { CadastroLoteLancamentosDialogComponent } from './cadastro-lote-lancamentos-dialog.component';

@NgModule({
  declarations: [
    CadastroLoteLancamentosDialogComponent,
  ],
  imports: [
    SharedModule,
    MaterialModule,
    CadastroLoteLancamentosModule,
  ],
  exports: [
    CadastroLoteLancamentosDialogComponent,
  ],
})
export class CadastroLoteLancamentosDialogModule { }
